// React
import React from 'react'

export default ({ status, text }) => (
	status ? (
		<div className='capps-loading'>
			{text}
		</div>
	) : null
)



// WEBPACK FOOTER //
// ./src/Components/Display/Loading.js